var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #662d89;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.11,
    y: 0.11,
    width: 99.77,
    height: 99.77,
    rx: 20,
    ry: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.22,25.07s.12.1.25.11c1.17.06,2.33.1,3.5.2v8.55c-1.6.07-3.26-.09-4.85,0-1.85.09-3.79.3-4.51,2.27-.09.25-.34,1.12-.34,1.33v7.04h9.38l-1.3,9.59h-8.08v24.29h-9.9v-24.29h-8.13v-9.59h8.13c.13-5.41-.88-11.69,3.12-16,1.81-1.94,4.87-3.28,7.51-3.49,1.52-.12,3.66-.07,5.21,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookTheme);
export default __webpack_public_path__ + "static/media/facebook_theme.961283c9eb403278d6a133c9e5549f40.svg";
export { ForwardRef as ReactComponent };